import React, { useState, useEffect } from "react";
import axios from "axios";
import {Stack,  Box, Typography, useTheme, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme.js";

import urls from './../../constants/urls';
//import { schoolsData } from "../../data/mockData.js";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import Header from "../../components/Header.jsx";
import SchoolTeachersData from "./SchoolTeachersData.jsx";
import SchoolTeachersRegistration from "./SchoolTeachersRegistration.jsx";
import SchoolTeachersUpdate from "./SchoolTeachersUpdate.jsx";
import SchoolTeachersSubjects from "./SchoolTeachersSubjects.jsx";



//import { Button } from "antd";
//PCEditModal
//import UpdateModal from "./UpdateModal.jsx";


const SchoolTeachers = ( {schoolIdGlobal } ) => {
  
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [showSchoolTeachersForm, setShowSchoolTeachersForm]=useState(true);
  const [showSchoolTeachersData, setShowSchoolTeachersData]=useState(false);
  const [showSchoolTeachersUpdate, setShowSchoolTeachersUpdate]=useState(false);
  const [showSchoolTeachersSubject, setShowSchoolTeachersSubject]=useState(false);
 
  const [buttonOneTitle, setButtonOneTitle]=useState('SCHOOL TEACHERS DATA')
  
  //
  const[usersId, setUsersId]=useState(0);
  const [firstName, setFirstName]=useState('');
  const [middleName, setMiddleName]=useState('');
  const [lastName, setLastName]=useState('');
  const [fullName, setFullName]=useState('');
  const [mobileNumber, setMobileNumber]=useState('');
  const[schoolId, setSchoolId]=useState(schoolIdGlobal);
  const[schoolName, setSchoolName]=useState('');
  const[wardId, setWardId]=useState(0);
  
  const[districtId, setDistrictId]=useState(0);
  const[cityId, setCityId]=useState(0);
  
  const[wardName, setWardName]=useState('');
  const[districtName, setDistrictName]=useState('');
  const[cityName, setCityName]=useState('');

  const[schoolCode, setSchoolCode]=useState('');
  const[street, setStreet]=useState('');
  const[plotNumber, setPlotNumber]=useState('');
  
  const[areaDetails, setAreaDetails]=useState('');
  const[telephoneNumber1, setTelephoneNumber1]=useState('');
  const[telephoneNumber2, setTelephoneNumber2]=useState('');

  const[email, setEmail]=useState('');
  const[userPassword, setUserPassword]=useState('');
  const[website, setWebsite]=useState('');

  
  const handleButtonOneClick=()=>{
    if(showSchoolTeachersForm===false){
      setShowSchoolTeachersForm(true);
      setShowSchoolTeachersData(false);
      setShowSchoolTeachersUpdate(false);
      setShowSchoolTeachersSubject(false);
      setButtonOneTitle('SCHOOL TEACHERS DATA');
    }
    else if(showSchoolTeachersData===false){
      setShowSchoolTeachersData(true);
      setShowSchoolTeachersForm(false);
      setShowSchoolTeachersUpdate(false);
      setShowSchoolTeachersSubject(false);
      setButtonOneTitle('SCHOOL TEACHER FORM');
    }
    else if(showSchoolTeachersSubject===false){
      setShowSchoolTeachersSubject(true);
      setShowSchoolTeachersData(false);
      setShowSchoolTeachersForm(false);
      setShowSchoolTeachersUpdate(false);
      setButtonOneTitle('SCHOOL TEACHER FORM');
    }
    else{

    }
  }


   ///                    users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email
  ///                      usersId, firstName, wardId, districtId, cityId, mobileNumber, cityName, middleName, lastName, fullName, gender, date_of_birth, passwordId, userPassword, loginCategoryId, loginCategoryName, schoolId, schoolName, userEmail
    const handleShowUpdate=(category, usersId, firstName, wardId, districtId, cityId, mobileNumber, cityName, middleName, lastName, fullName, gender, date_of_birth, passwordId, userPassword, loginCategoryId, loginCategoryName, schoolId, schoolName, userEmail)=>{
    console.log("inside userEmail=" + userEmail) 
      
    if(category==="update"){
      setShowSchoolTeachersUpdate(true);
      setShowSchoolTeachersSubject(false);
      setShowSchoolTeachersData(false);
      setShowSchoolTeachersForm(false);
    }
    else if(category==="subjects"){
      setShowSchoolTeachersSubject(true);
      setShowSchoolTeachersUpdate(false);
      setShowSchoolTeachersData(false);
      setShowSchoolTeachersForm(false);
    }
    else{

    }
     

    setUsersId(usersId); //setUsersId
    setSchoolName(schoolName);
    setFirstName(firstName); //setUsersId
    setMiddleName(middleName); //setUsersId
    setLastName(lastName); //setUsersId
    setFullName(fullName); //setUsersId
    setMobileNumber(mobileNumber); //setUsersId
    setWardId(wardId);
    setSchoolName(schoolName);
    //setWardId(wardId);
    setDistrictId(districtId);
    setCityId(cityId);
  
    setWardName(wardName);
    setDistrictName(districtName)
    setCityName(cityName);

     setSchoolCode(schoolCode);
     setStreet(street);
     setPlotNumber(plotNumber);
  
     setAreaDetails(areaDetails);
     setTelephoneNumber1(telephoneNumber1);
     setTelephoneNumber2(telephoneNumber2);

      setEmail(userEmail);
      setUserPassword(userPassword)
      setWebsite(website);



  }
  

  const handleShowSubjects=(usersId, firstName, wardId, districtId, cityId, mobileNumber, cityName, middleName, lastName, fullName, gender, date_of_birth, passwordId, userPassword, loginCategoryId, loginCategoryName, schoolId, schoolName, userEmail)=>{
    console.log("inside userEmail=" + userEmail) 
    setShowSchoolTeachersUpdate(true);
      setShowSchoolTeachersData(false);
      setShowSchoolTeachersForm(false);

    setUsersId(usersId); //setUsersId
    setSchoolName(schoolName);
    setFirstName(firstName); //setUsersId
    setMiddleName(middleName); //setUsersId
    setLastName(lastName); //setUsersId
    setFullName(fullName); //setUsersId
    setMobileNumber(mobileNumber); //setUsersId
    setWardId(wardId);
    setSchoolName(schoolName);
    //setWardId(wardId);
    setDistrictId(districtId);
    setCityId(cityId);
  
    setWardName(wardName);
    setDistrictName(districtName)
    setCityName(cityName);

     setSchoolCode(schoolCode);
     setStreet(street);
     setPlotNumber(plotNumber);
  
     setAreaDetails(areaDetails);
     setTelephoneNumber1(telephoneNumber1);
     setTelephoneNumber2(telephoneNumber2);

      setEmail(userEmail);
      setUserPassword(userPassword)
      setWebsite(website);



  }

  return (
    <Box m="20px">
      <Header title="SCHOOL TEACHERS" subtitle="Managing the School Admins" />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      > 
        <Stack direction="row" spacing={1}>
        <Box flex={4}> 

        <Button 
          title={buttonOneTitle} 
          onClick={()=>handleButtonOneClick()}
          color="secondary" variant="contained"
          sx={{width: "50%"}}
          >
          {buttonOneTitle} 
          </Button>
        </Box>
          <Box flex={4}>
          
          </Box>
          <Box flex={4}> </Box>
        </Stack>
        <br />
        {
         showSchoolTeachersData? <SchoolTeachersData 
         sendDataToParent={handleShowUpdate} schoolIdGlobal={schoolIdGlobal} />: ''
        }

        {
         showSchoolTeachersForm? 
         <SchoolTeachersRegistration schoolId={schoolIdGlobal } />: ''
        }
       
       {
        showSchoolTeachersUpdate? 
        <SchoolTeachersUpdate 
        usersId={usersId}
        firstName={firstName} 
        middleName={middleName} 
        lastName={lastName} 
        fullName={fullName}  
        mobileNumber={mobileNumber}
        schoolId={schoolId} 
        schoolName={schoolName} 
        
        wardName={wardName} 
        districtName= {districtName}
        cityName={cityName} 
        schoolCode={schoolCode} 
        street={street} 
        plotNumber={plotNumber} 
        areaDetails={areaDetails} 
        telephoneNumber1={telephoneNumber1} 
        telephoneNumber2={telephoneNumber2}
         userEmail={email} 
         website={website}
         userPassword={userPassword}
        />: ''
       }
       

        {
        showSchoolTeachersSubject? 
        <SchoolTeachersSubjects
        usersId={usersId}
        firstName={firstName} 
        middleName={middleName} 
        lastName={lastName} 
        fullName={fullName}  
        mobileNumber={mobileNumber}
        schoolId={schoolId} 
        schoolName={schoolName} 
        
        wardName={wardName} 
        districtName= {districtName}
        cityName={cityName} 
        schoolCode={schoolCode} 
        street={street} 
        plotNumber={plotNumber} 
        areaDetails={areaDetails} 
        telephoneNumber1={telephoneNumber1} 
        telephoneNumber2={telephoneNumber2}
         userEmail={email} 
         website={website}
         userPassword={userPassword}
        />: ''
       }


       {/***<UpdateModal />***/}
      </Box>
    </Box>
  );
};

export default SchoolTeachers;
